import { render, staticRenderFns } from "./lessonRecommendDetail.vue?vue&type=template&id=23befa68&scoped=true&"
import script from "./lessonRecommendDetail.vue?vue&type=script&lang=js&"
export * from "./lessonRecommendDetail.vue?vue&type=script&lang=js&"
import style0 from "./lessonRecommendDetail.vue?vue&type=style&index=0&id=23befa68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23befa68",
  null
  
)

export default component.exports